import './coreRuntimeSetup'; // CoreRuntime ядра — инициализировать ДО первого рендера
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, onlineManager } from '@tanstack/react-query';
import App from './App';
import { captureEntryParams } from './utils/entryParams';
import { applyEarlyBrandHead } from './brandHeadSync';
import './index.css';

// White-label: манифест, иконки и название — заведения из URL, ставим до загрузки заведения (Chrome читает
// манифест лениво, но адрес должен быть на месте к «Установить»). На корне / — статический манифест Lunit.
applyEarlyBrandHead();

// Ссылка друга (?ref=) или подарок (?gift=): запомнить коды до того, как гвард уведёт гостя на вход.
captureEntryParams(window.location.pathname.split('/').filter(Boolean)[0] || '');

// Одноразовая чистка старого api-cache: прошлый SW кэшировал ВСЁ /api/v1/* (включая личные баланс/
// историю). После cache-split (vite.config) удаляем протухший кэш, чтобы не отдать чужие данные.
if ('caches' in window) {
  void caches.delete('api-cache');
}

// Keep React Query aware of online/offline status
onlineManager.setEventListener((setOnline) => {
  const handleOnline = () => setOnline(true);
  const handleOffline = () => setOnline(false);

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
